import React from "react";
import { NavLink, useLocation } from "react-router-dom";

const items = [
  { label: "Districts", path: "/districts" },
  { label: "Sub-divisions", path: "/sub-divisions" },
  { label: "Stations", path: "/stations" },
  { label: "Users", path: "/users" },
  { label: "Role Access", path: "/masters/role-access" },
];

export default function MastersNav() {
  const location = useLocation();

  return (
    <div className="masters-nav">
      {items.map((item) => {
        const isActive =
          location.pathname === item.path ||
          location.pathname.startsWith(`${item.path}/`);

        return (
          <NavLink
            key={item.path}
            className={`masters-nav__link ${
              isActive ? "masters-nav__link--active" : ""
            }`.trim()}
            to={item.path}
          >
            {item.label}
          </NavLink>
        );
      })}
    </div>
  );
}
